import React, { FunctionComponent, useEffect, useRef, useState } from 'react';
import styles from './SignIn.module.scss';
import { LoginPattern } from 'app/assets/images/icons';
import { _t } from 'app/utils/i18n';
import TextInput from 'app/components/Form/Inputs/TextInput';
import { path } from 'app/utils/path';
import CheckBox from 'app/components/Form/Inputs/CheckBox';
import { useCustomForm } from 'app/hooks/useCustomForm';
import { validationSchema } from './loginSchema';
import { useHistory } from 'react-router';
import {
  constants,
  getFromLocalStorage,
  setInLocalStorage,
} from 'app/utils/localStorage';
import { login } from 'auth/Requests';

import { useQueryClient, useMutation } from 'react-query';
import { useAuth } from 'app/context/auth';
import { Link } from 'react-router-dom';
import { ModalComponent } from 'app/components/ModalComponent/ModalComponent';
import ReCAPTCHA from 'react-google-recaptcha';
import { navigateWithSearchState } from 'app/utils/search-state';
import { checkIsMockGoogleRecaptcha } from 'app/utils/check-mock-google-recaptcha';

const Login: FunctionComponent = () => {
  useEffect(() => {
    const token = getFromLocalStorage('access_token');
    token && history.push(path.home);
  }, []);
  const reRef = useRef<ReCAPTCHA>();

  const [errorMsg, setErrorMsg] = useState();
  const loginMutation = useMutation(login, {
    onError: (error: any) => {
      const err = error?.response?.data?.message;
      const errorCode = error?.response?.data?.code;
      setErrorMsg(errorCode != 404 ? _t('basic:user_blocked') : err);
    },
  });
  const auth = useAuth();

  const setLang = (lng: string) => {
    setInLocalStorage(constants.language, lng);
    location.reload();
  };
  const currentLanguage = getFromLocalStorage(constants.language);
  const history = useHistory();
  const queryClient = useQueryClient();

  const {
    location: { pathname },
  } = history;
  const onSubmit = async (values: any) => {
    let token = '';
    if (checkIsMockGoogleRecaptcha()) {
      token = await reRef.current.executeAsync();
      reRef.current.reset();
    }
    try {
      const result = await loginMutation.mutateAsync({
        body: values,
        token,
      });

      if (result?.payload?.records?.two_factor_enabled) {
        history?.replace(
          navigateWithSearchState(path.auth.SECOND_AUTHENTICATION, {
            user_id: result?.payload?.records?.user_id,
            remember_me: values?.remember_me,
          }),
        );
        return;
      } else {
        auth.login({
          ...result?.payload?.records,
          remember_me: values?.remember_me,
        });
        history.replace(path.home);
      }

      if (pathname === path.auth.REDIRECT_SIGN_IN) {
        history?.goBack();
      }
      await queryClient.refetchQueries({ stale: true });
    } catch (error) {}
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    changeHandler: FormOnChange,
    getValues,
  } = useCustomForm(validationSchema, {
    remember_me: true,
  });
  const values = getValues();

  return (
    <>
      {checkIsMockGoogleRecaptcha() && (
        <ReCAPTCHA
          sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY as any}
          size="invisible"
          ref={reRef as any}
        />
      )}
      {errorMsg && (
        <div
          onClick={() => {
            setErrorMsg(undefined);
          }}
        >
          <ModalComponent
            message={errorMsg}
            hideOnCancel
            onOkText={_t('basic:thanks')}
            videoModule
            fullScreen
          />
        </div>
      )}

      <div className={styles.SignIn}>
        <LoginPattern />
        <div className={styles.loginBox}>
          <form
            className={styles.Form} // {`${styles.Form} ${styles.wrong}`}
            onSubmit={handleSubmit(onSubmit)}
          >
            <h4> {_t('login:login')}</h4>
            <span>{_t('login:wrong')}</span>
            <div className="mb-20">
              <span className={styles.fieldSpan}>{_t('login:field')}</span>
              <TextInput
                label={_t('login:email')}
                type="text"
                name="email"
                register={register}
                error={errors?.email?.message}
              />
            </div>
            <div className="mb-20">
              <span className={styles.fieldSpan}>{_t('login:field')}</span>
              <TextInput
                label={_t('login:password')}
                type="password"
                name="password"
                register={register}
                error={errors?.password?.message}
              />
            </div>
            <div className={`${styles.checkParent} mb-20`}>
              <CheckBox
                label={_t('login:trust_this_computer')}
                htmlFor={'remember_me'}
                checked={values.remember_me}
                onChange={(val: any) => {
                  FormOnChange('remember_me', val.target.checked);
                }}
              />
              <Link to={path.auth.FORGOT_PASSWORD}>
                {_t('login:forgot_password')}
              </Link>
            </div>
            <div className={styles.button_Box}>
              <button type="submit">{_t('login:Login')}</button>
              {currentLanguage == 'en' ? (
                <a onClick={() => setLang('ar')} style={{ cursor: 'pointer' }}>
                  {_t('basic:ar')}
                </a>
              ) : (
                <a onClick={() => setLang('en')} style={{ cursor: 'pointer' }}>
                  {_t('basic:en')}
                </a>
              )}
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Login;
